import MainLayout from 'components/layout/Main';
import FinanceFooter from 'components/shared/FinanceFooter';
import { ReactNode } from 'react';
import BackStepButton from '../BackStepButton';
import EnquiryHeader from '../Header';
import EnquiryProgressBar from '../ProgressBar';
import EnquiryLayoutSidebar from '../Sidebar';
import ApplySteps from '../Steps';

export interface EnquiryContentProps {
  children: ReactNode;
  isLoading?: boolean;
}

const EquiryLayout: React.FunctionComponent<EnquiryContentProps> = function ({
  children,
  isLoading = false,
}) {
  return (
    <MainLayout
      headerContent={EnquiryHeader}
      headerAppend={<EnquiryProgressBar />}
      sidebarContent={<EnquiryLayoutSidebar />}
      footer={<FinanceFooter marginClassName="px-6 md:px-12 pt-8 !text-left" />}
    >
      <div className="flex flex-col flex-1 pb-8 pt-4 px-6 md:px-10 lg:px-15">
        <div className="flex flex-1 flex-row gap-x-8">
          <div className="hidden lg:block relative w-50 min-w-50">
            <div className="sticky top-26">
              <ApplySteps isLoading={isLoading} />
            </div>
          </div>
          <div className="flex w-full">
            <div className="flex flex-col w-full max-w-120 mx-auto">
              <BackStepButton />
              {children}
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EquiryLayout;
